import { TableColumnsSetting } from '@/interfaces/table-setting';
import { VwfsFrameModel } from '@/models/imports/vwfs-frame-model';

export class VwfsFrameSettingsTable {
  public static getColumnsSetting(): TableColumnsSetting<keyof VwfsFrameModel | 'btnDetails'> {
    return [
      {
        name: 'btnDetails',
        text: 'Dettagli',
      },
      {
        name: 'id',
        text: 'Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'importId',
        text: 'Import Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'idDocument',
        text: 'Id Documento',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'telaioNumeroPraticaProcedura',
        text: 'Telaio Numero Pratica Procedura',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'numOrdine',
        text: 'Num. Ordine',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'procedura',
        text: 'Procedura',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'numeroPratica',
        text: 'Num. Pratica',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'telaio',
        text: 'Telaio',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'createdAt',
        type: 'datetime',
        text: 'Creato il',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'updatedAt',
        type: 'datetime',
        text: 'Modificato il',
        filter: {
          type: 'dateRange',
        },
      },
    ];
  }
}
